import { Check } from "lucide-react";
import { PriorityBadge } from "@/components/common";
import { PRIORITY, eventMeta, fmtShort, timeAgo } from "@/lib/fleet";
import { cn } from "@/lib/utils";

export function EventItem({ e, onAck, compact }) {
  const meta = eventMeta(e.type);
  const Icon = meta.icon;
  return (
    <div className={cn("flex items-start gap-3 rounded-xl px-3 py-2.5 transition-colors hover:bg-accent/60", compact && "py-2")} data-testid={`event-item-${e.id}`}>
      <div className={cn("mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border", PRIORITY[e.priority]?.cls)}>
        <Icon className="h-4 w-4" />
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <span className="truncate text-[13px] font-semibold">{e.title}</span>
          <PriorityBadge priority={e.priority} />
        </div>
        <div className="truncate text-xs text-muted-foreground">{e.vehicle_name} · <span className="font-mono">{e.plate}</span> — {e.message}</div>
      </div>
      <div className="flex shrink-0 flex-col items-end gap-1">
        <span className="font-mono text-[10.5px] text-muted-foreground" title={fmtShort(e.created_at)}>{compact ? timeAgo(e.created_at) : fmtShort(e.created_at)}</span>
        {onAck && !e.acknowledged && (
          <button onClick={() => onAck(e.id)} className="flex items-center gap-1 rounded-md border border-border px-1.5 py-0.5 text-[10px] font-semibold hover:border-primary hover:text-primary" data-testid={`event-ack-${e.id}`}>
            <Check className="h-3 w-3" /> Tangani
          </button>
        )}
        {onAck && e.acknowledged && <span className="text-[10px] text-emerald-500">Ditangani</span>}
      </div>
    </div>
  );
}
